export const FILE_UPLOAD_VALIDATION = {
  FORMAT: 'Only JPEG, JPG, and PNG files are allowed.',
  FILE_SIZE: 'File size should be between 1KB and 8MB.',
};

export const ALLOWED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png'];

export const validateFileSize = (size) => {
  return size >= 1024 && size / 1024 / 1024 <= 8;
};
